import React from "react";
import { makeStyles } from "@material-ui/core/styles";
// import Paper from "@material-ui/core/Paper";
// import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
// import Divider from "@material-ui/core/Divider";

import TodoList from "./TodoList";
import Todos from "./Main/Todos";
// import Doings from "./Main/Doings";
// import Completed from "./Main/Completed";

import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2),
    height: 550,
    overflow: "auto"
  }
}));

export default function MainContent(props) {
  const classes = useStyles();
  const {
    data,
    currentTab,
    deleteDataHandler,
    changeStatusStateHandler,
    updateDataHandler,
    dropStateHandler
  } = props;

  const filterByStatus = status =>
    data
      .filter(data => data.status === status)
      .sort((a, b) => {
        var c = new Date(a.deadline);
        var d = new Date(b.deadline);
        return c - d;
      })
      .map(element => {
        return (
          <TodoList
            key={element._id}
            data={element}
            deleteDataHandler={deleteDataHandler}
            changeStatusStateHandler={changeStatusStateHandler}
            updateDataHandler={updateDataHandler}
          />
        );
      });

  const todo = filterByStatus("todo");
  const doing = filterByStatus("doing");
  const completed = filterByStatus("completed");

  const renderSwitch = currentTab => {
    switch (currentTab) {
      case 1:
        return (
          <React.Fragment>
            <Grid item xs></Grid>
            <Grid item xs>
              <Todos
                classes={classes.root}
                list={todo}
                who={"Todo"}
                dropStateHandler={dropStateHandler}
              />
            </Grid>
            <Grid item xs></Grid>
          </React.Fragment>
        );
      case 2:
        return (
          <React.Fragment>
            <Grid item xs></Grid>
            <Grid item xs>
              <Todos
                classes={classes.root}
                list={doing}
                who={"Doing"}
                dropStateHandler={dropStateHandler}
              />
            </Grid>
            <Grid item xs></Grid>
          </React.Fragment>
        );
      case 3:
        return (
          <React.Fragment>
            <Grid item xs></Grid>
            <Grid item xs>
              <Todos
                classes={classes.root}
                list={completed}
                who={"Completed"}
                dropStateHandler={dropStateHandler}
              />
            </Grid>
            <Grid item xs></Grid>
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            <Grid item xs>
              <Todos
                classes={classes.root}
                list={todo}
                who={"Todo"}
                dropStateHandler={dropStateHandler}
              />
            </Grid>
            <Grid item xs>
              <Todos
                classes={classes.root}
                list={doing}
                dropStateHandler={dropStateHandler}
                who={"Doing"}
              />
            </Grid>
            <Grid item xs>
              <Todos
                classes={classes.root}
                list={completed}
                who={"Completed"}
                dropStateHandler={dropStateHandler}
              />
            </Grid>
          </React.Fragment>
        );
    }
  };

  // console.log(classes.root);
  // console.log(data, currentTab);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="main-content">
        <Grid container spacing={3}>
          {renderSwitch(currentTab)}
        </Grid>
      </div>
    </DndProvider>
  );
}
